/**
 * Public tenant-site path builders — the ONE place that knows the app's
 * route shapes (apps/app routesNew.tsx), so admin/app/next-app links can't
 * drift from them. Paths only; origins come from `domains.ts`
 * (tenantOrigin/orgOrigin — or apps/admin's env-aware publicSiteUrl).
 *
 * Born 2026-10-07: the admin's "View on Site" division link first shipped
 * hand-built with the ORG NAME as the leading segment; the real shape is
 * `/<contestType>/:leagueId/division/:divisionId` where the first segment is
 * 'season' | 'tournament' (the League's ADR 0009 discriminator).
 */

interface LeagueLike {
  contestType?: string | null;
  /** Set (id or populated doc) only on tournament contests — ADR 0009. */
  tournament?: unknown;
}

/** 'tournament' when the league is a tournament contest, else 'season'. */
export function publicContestSegment(league: LeagueLike | null | undefined): 'season' | 'tournament' {
  if (!league) return 'season';
  return league.contestType === 'tournament' || league.tournament ? 'tournament' : 'season';
}

/** Path of a division's public page: /<season|tournament>/:leagueId/division/:divisionId */
export function publicDivisionPath(
  league: LeagueLike | null | undefined,
  leagueId: string,
  divisionId: string,
): string {
  return `/${publicContestSegment(league)}/${leagueId}/division/${divisionId}`;
}

/** Path of a division's public standings tab: publicDivisionPath + "/standing" */
export function publicDivisionStandingsPath(
  league: LeagueLike | null | undefined,
  leagueId: string,
  divisionId: string,
): string {
  return `${publicDivisionPath(league, leagueId, divisionId)}/standing`;
}
